export const CREDIT_TRACKER_ADMIN_FILTERS_LABEL = {
  JURISDICTIONS: 'Jurisdictions',
  COMPLIANCE_GROUPS: 'Compliance groups'
} as const;
